import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const FittingListState = Immutable.fromJS({
	fittingList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1,
	searchWord: ''
});

const fittingListReducer = handleActions({
	FIND_FITTING_LIST: (state, { payload }) => {
		return state.merge({
			fittingList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage,
			searchWord: payload.data.searchWord,
		})
	},
	CHANGE_FITTING_ACTIVE_PAGE:(state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	},
}, FittingListState);

export default fittingListReducer;


// WEBPACK FOOTER //
// ./src/reducers/fittingListReducer.js